import { render } from "./ModelButton.vue?vue&type=template&id=f22ce902"
import script from "./ModelButton.vue?vue&type=script&lang=js"
export * from "./ModelButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__